import { render, staticRenderFns } from "./review-component-renderer.vue?vue&type=template&id=6da469ba&scoped=true"
import script from "./review-component-renderer.vue?vue&type=script&lang=js"
export * from "./review-component-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da469ba",
  null
  
)

export default component.exports